import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md mx-auto">
        <div className="mb-8">
          <div className="w-24 h-24 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="AlertCircle" size={48} className="text-secondary-400" />
          </div>
          <h1 className="text-6xl font-bold text-text-primary mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-text-primary mb-4">
            Страница не найдена
          </h2>
          <p className="text-text-secondary mb-8">
            Запрашиваемая страница не существует или была перемещена. 
            Проверьте правильность введенного адреса.
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate('/login-screen')}
            className="
              w-full bg-primary text-white px-6 py-3 rounded-md font-medium
              hover:bg-primary-700 transition-colors duration-150 hover-lift
              focus:outline-none focus:ring-2 focus:ring-primary/20
            "
          >
            Вернуться на главную
          </button>
          
          <button
            onClick={() => navigate(-1)}
            className="
              w-full border border-secondary-300 text-text-primary px-6 py-3 rounded-md font-medium
              hover:bg-secondary-50 transition-colors duration-150 hover-lift
              focus:outline-none focus:ring-2 focus:ring-primary/20
            "
          >
            Назад
          </button>
        </div>

        <div className="mt-8 pt-8 border-t border-secondary-200">
          <p className="text-sm text-text-secondary">
            Если проблема повторяется, обратитесь к системному администратору
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;